import {
    makeKey,
    update,
    handleApiResponseError,
    handleNetworkError
} from '../../../../utils/reducerOperations';
export function handleLoginProcessFailed(state, payload) {
    if (payload.response && payload.response.data) {
        return makeKey(
            'SSOLoginApi',
            update(
                state.SSOLoginApi,
                handleApiResponseError(payload.response.data)
            )
        );
    } else {
        return makeKey(
            'SSOLoginApi',
            update(
                state.loginProcessApi,
                handleNetworkError(payload)
            )
        );
    }
}
